<template>
    <v-layout>
        <v-dialog v-model="isShowDialog" max-width="35rem">
            <v-card>
                <v-card-title class="secondary elevation-4 white--text">
                    <div class="text-h5">
                        <v-icon class="pb-1" color="white" medium>
                            {{ icon }}
                        </v-icon>
                        <slot name="dialogHeader" />
                    </div>
                </v-card-title>
                <slot name="dialogError" />
                <v-card-text class="message pa-4">
                    <slot name="dialogMessage" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <button-app-control
                        ref="cancel-btn"
                        :disabled="disabled"
                        :label="$t('Cancel')"
                        text
                        @click="closeDialog()"
                    />
                    <button-app-control ref="submit-btn" :disabled="disabled" :label="btnWord" @click="runAction()" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ButtonAppControl } from '../../atoms';

@Component({
    name: 'TheActionDialog',
    components: {
        ButtonAppControl,
    },
})
export default class TheActionDialog extends Vue {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: '' }) actionName: string;
    @Prop({ default: '' }) btnWord: string;
    @Prop({ default: '' }) icon: string;

    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }
    closeDialog(): void {
        this.$emit('cancel-dialog');
    }
    runAction(): void {
        this.$emit('run-action', this.actionName);
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
